export function Logo({ className = "h-8 w-8", withText = false, textClass = "" }) {
  return (
    <span className="inline-flex items-center gap-2" data-testid="tubmix-logo">
      <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="tubmixGrad" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FF5500" />
            <stop offset="1" stopColor="#6366F1" />
          </linearGradient>
        </defs>
        <rect x="2" y="2" width="44" height="44" rx="12" fill="#0B0D12" />
        <rect x="9" y="20" width="4" height="8" rx="2" fill="url(#tubmixGrad)" />
        <rect x="16" y="14" width="4" height="20" rx="2" fill="url(#tubmixGrad)" />
        <rect x="23" y="8" width="4" height="32" rx="2" fill="url(#tubmixGrad)" />
        <rect x="30" y="14" width="4" height="20" rx="2" fill="url(#tubmixGrad)" />
        <rect x="37" y="20" width="4" height="8" rx="2" fill="url(#tubmixGrad)" />
      </svg>
      {withText && (
        <span className={`font-heading font-extrabold tracking-tight ${textClass}`}>TUBMIX</span>
      )}
    </span>
  );
}
